// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"404":"cbcfd901","498":"9727cf8b","598":"d6fd4698","787":"d407700a"}[chunkId] + ".chunk.js";
};